import { simpleLeadTracker } from "./simpleLeadTracker"
import { theIndoorGardens } from "./theIndoorGardens"
import { narrativePlanner } from "./narrativePlanner"
import { myDailyFortune } from "./myDailyFortune"
import { homeOwners } from "./homeOwners"
import { thePixelArtist } from "./thePixelArtist"
import { dungeonMaker } from "./dungeonMaker"
import { rpgAdventureManager } from "./rpgAdventureManager"
import { simpleGoalsTracker } from "./simpleGoalsTracker"
import { simpleWorkPlanner } from "./simpleWorkPlanner"
import { dailyHabitTracker } from "./dailyHabitTracker"
import { entrepreneursjumpstart } from "./entrepreneursjumpstart"
import { writeProgress } from "./writeProgress"

export const projects = [
  simpleLeadTracker,
  theIndoorGardens,
  narrativePlanner,
  homeOwners,
  writeProgress,
  myDailyFortune,
  thePixelArtist,
  dungeonMaker,
  rpgAdventureManager,
  simpleGoalsTracker,
  simpleWorkPlanner,
  dailyHabitTracker,
  entrepreneursjumpstart,
]
